import React from "react";
import GoogleSvg from "../../../components/svgs/GoogleSvg";
import AppleSvg from "../../../components/svgs/AppleSvg";

export default function Socials({ handleGoogleSignIn, handleAppleSignIn }) {
  return (
    <div className="social-container">
      <a
        href="#"
        className="social"
        onClick={(e) => {
          e.preventDefault();
          handleGoogleSignIn();
        }}
      >
        <GoogleSvg height={25} width={25} />
      </a>
      <a
        href="#"
        className="social"
        onClick={(e) => {
          e.preventDefault();
          handleAppleSignIn();
        }}
      >
        <AppleSvg height={25} width={25} />
      </a>
    </div>
  );
}
